import(/* webpackMode: "eager", webpackExports: ["PrivacyPolicyContent"] */ "/home/runner/work/whoplays-web/whoplays-web/src/app/(marketing)/privacy-policy/content.tsx");
